const rawCommit = import.meta.env.VITE_BUILD_COMMIT || 'dev';
const rawBuildDate = import.meta.env.VITE_BUILD_DATE || 'local';
const rawBuildRef = import.meta.env.VITE_BUILD_REF || '';

const PLACEHOLDER_VALUES = new Set(['dev', 'local', 'unknown']);

function normalizeValue(value: string): string {
  const normalized = value.trim();
  return normalized || 'unknown';
}

function formatUtcDate(value: string): string {
  const normalized = normalizeValue(value);
  if (PLACEHOLDER_VALUES.has(normalized.toLowerCase())) return normalized;

  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return normalized;

  const dd = String(date.getUTCDate()).padStart(2, '0');
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const yyyy = date.getUTCFullYear();
  const hh = String(date.getUTCHours()).padStart(2, '0');
  const min = String(date.getUTCMinutes()).padStart(2, '0');

  return `${dd}.${mm}.${yyyy} ${hh}:${min} UTC`;
}

function shortCommit(value: string): string {
  const normalized = normalizeValue(value);
  if (PLACEHOLDER_VALUES.has(normalized.toLowerCase())) return normalized;
  return normalized.slice(0, 7);
}

export const BUILD_COMMIT = normalizeValue(rawCommit);
export const BUILD_DATE = normalizeValue(rawBuildDate);
export const BUILD_REF = rawBuildRef.trim();
export const BUILD_COMMIT_SHORT = shortCommit(BUILD_COMMIT);
export const formattedBuildDate = formatUtcDate(BUILD_DATE);

export const buildInfoTitle = [
  `commit: ${BUILD_COMMIT}`,
  `date: ${BUILD_DATE}`,
  BUILD_REF ? `ref: ${BUILD_REF}` : null,
]
  .filter(Boolean)
  .join('\n');
